declare global {
  interface Window {
    _env_: {
      API_URL?: string;
      CLIENT_URL?: string;
    };
  }
}

const API_BASE_URL = window._env_?.API_URL || process.env.REACT_APP_API_URL || "http://localhost:8181/v1";
const CLIENT_BASE_URL = window._env_?.CLIENT_URL || process.env.REACT_APP_CLIENT_URL || "http://localhost:3000";

export { API_BASE_URL, CLIENT_BASE_URL };